import Vue from 'vue'
import App from './App'
import Cookies from 'js-cookie'
import {
  Alert,
  Button,
  ButtonGroup,
  Card,
  Checkbox,
  Col,
  DatePicker,
  Dialog,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Form,
  FormItem,
  Input,
  InputNumber,
  Loading,
  Message,
  MessageBox,
  Option,
  OptionGroup,
  Popover,
  Radio,
  RadioGroup,
  Row,
  Select,
  Step,
  Steps,
  Table,
  TableColumn,
  Tabs,
  TabPane,
  Tag,
  Tooltip,
} from 'element-ui'
import 'simplemde/dist/simplemde.min.css'
import 'es6-promise/auto'
import axios from 'axios'
import router from './router'
import store from './store'
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
import './assets/css/main.css'
import './assets/css/element-ui.css'
import './element-variables.scss'

locale.use(lang)

Vue.config.productionTip = process.env.NODE_ENV !== 'production'

// Vue.use(Element, { locale })

Vue.use(Alert)
Vue.use(Button)
Vue.use(ButtonGroup)
Vue.use(Card)
Vue.use(Checkbox)
Vue.use(Col)
Vue.use(DatePicker)
Vue.use(Dialog)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(InputNumber)
Vue.use(Option)
Vue.use(OptionGroup)
Vue.use(Popover)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Select)
Vue.use(Step)
Vue.use(Steps)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Tooltip)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Tag)
Vue.use(Row)

Vue.use(Loading.directive)

Vue.prototype.$loading = Loading.service
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$message = Message

axios.defaults.baseURL = process.env.VUE_APP_API_HOST
axios.defaults.timeout = 15000
axios.defaults.withCredentials = true

if (Cookies.get('nc_session')) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${ Cookies.get('nc_session') }`
}

Vue.prototype.$http = axios

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
